// Feature Flags for Collaborative Features
// This allows us to enable/disable features without code changes

export const FEATURE_FLAGS = {
  // Core collaborative features
  GROUP_PROGRESS_DASHBOARD: true,
  LESSON_DISCUSSIONS: true,
  ACHIEVEMENT_SYSTEM: true,
  
  // Advanced features (disabled initially)
  STUDY_SESSIONS: false,
  GAMIFICATION: false,
  GROUP_CALENDAR: false,
  
  // Experimental features
  REAL_TIME_COLLABORATION: false,
  VOICE_NOTES: false,
  VIDEO_INTEGRATION: false
} as const

export type FeatureFlag = keyof typeof FEATURE_FLAGS

export const isFeatureEnabled = (feature: FeatureFlag): boolean => {
  return FEATURE_FLAGS[feature] || false
}

export const isFeatureEnabledForGroup = (feature: FeatureFlag, groupId?: string): boolean => {
  // For now, all features are enabled for all groups
  // Later we can add group-specific feature control
  return isFeatureEnabled(feature)
}

// Helper function to check multiple features
export const areFeaturesEnabled = (features: FeatureFlag[]): boolean => {
  return features.every(feature => isFeatureEnabled(feature))
}

// Get all enabled features
export const getEnabledFeatures = (): FeatureFlag[] => {
  return Object.keys(FEATURE_FLAGS).filter(
    key => isFeatureEnabled(key as FeatureFlag)
  ) as FeatureFlag[]
}

// Development helper - enable all features
export const enableAllFeatures = (): void => {
  Object.keys(FEATURE_FLAGS).forEach(key => {
    (FEATURE_FLAGS as any)[key] = true
  })
}

// Development helper - disable all features
export const disableAllFeatures = (): void => {
  Object.keys(FEATURE_FLAGS).forEach(key => {
    (FEATURE_FLAGS as any)[key] = false
  })
} 